import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

export const ProfitInsightsWidgetSkeleton = () => (
  <div className='box-border w-full h-full rounded-[12px] flex items-start p-[24px] flex-col'>
    <SkeletonTheme baseColor='#DFE2EB'>
      <div className='flex justify-between w-full'>
        <div className='flex'>
          <Skeleton width='120px' height='11px' borderRadius='13px' count={1} containerClassName='h-[11px] leading-3' />
        </div>
        <div className='flex'>
          <Skeleton width='100px' height='11px' borderRadius='13px' count={1} containerClassName='h-[11px] leading-3' />
        </div>
      </div>
      <div className='flex flex-col justify-between mt-[20px]'>
        <Skeleton width='120px' height='22px' borderRadius='8px' count={1} containerClassName='h-[22px] leading-3' />
      </div>
      <div className='flex flex-col mt-[75px] w-full'>
        <Skeleton width='60px' height='11px' borderRadius='13px' count={1} containerClassName='h-[11px] leading-3' />
        <div className='flex justify-between w-full mt-[10px]'>
          <div className='flex'>
            <Skeleton
              width='80px'
              height='11px'
              borderRadius='13px'
              count={1}
              containerClassName='h-[11px] leading-3'
            />
          </div>
          <div className='flex'>
            <Skeleton
              width='150px'
              height='11px'
              borderRadius='13px'
              count={1}
              containerClassName='h-[11px] leading-3'
            />
          </div>
        </div>
        <Skeleton
          width='60px'
          height='11px'
          borderRadius='13px'
          count={1}
          containerClassName='h-[11px] leading-3 mt-[20px]'
        />
        <div className='flex justify-between w-full mt-[10px]'>
          <div className='flex'>
            <Skeleton
              width='80px'
              height='11px'
              borderRadius='13px'
              count={1}
              containerClassName='h-[11px] leading-3'
            />
          </div>
          <div className='flex'>
            <Skeleton
              width='150px'
              height='11px'
              borderRadius='13px'
              count={1}
              containerClassName='h-[11px] leading-3'
            />
          </div>
        </div>
      </div>
    </SkeletonTheme>
  </div>
);
